import { render, staticRenderFns } from "./reservation-channel.vue?vue&type=template&id=337f0e14&"
import script from "./reservation-channel.vue?vue&type=script&lang=ts&"
export * from "./reservation-channel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VChip,VIcon,VImg,VListItemTitle})
